// components/Datenschutz.js
import React, { useEffect } from 'react';

export const Datenschutz = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
        }, []);    
  return (
    <div className="datenschutz">
      <div className="container">
        <h1>Datenschutz</h1>

        <p>
          Wir freuen uns, dass Sie unsere Website besuchen und bedanken uns für Ihr Interesse. Im Folgenden informieren wir Sie über den Umgang mit Ihren personenbezogenen Daten bei der Nutzung unserer Website. 
          Personenbezogene Daten sind hierbei alle Daten, mit denen Sie persönlich identifiziert werden können.
        </p>

        <p>
          Verantwortlicher für die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist Leon de Vries, Regensburger Straße 8, 90478 Nürnberg, Deutschland, 
          E-Mail: <a href="mailto:devries.leon@icloud.com">devries.leon@icloud.com</a>. Der für die Verarbeitung von personenbezogenen Daten Verantwortliche ist diejenige natürliche oder juristische Person, 
          die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
        </p>

        <p>
          Diese Website ist durch reCAPTCHA geschützt und es gelten die Datenschutzbestimmungen und Nutzungsbedingungen von Google.
        </p>

        <h2>1. Datenerfassung beim Besuch unserer Website</h2>
        <p>
          Bei der bloß informatorischen Nutzung unserer Website, also wenn Sie sich nicht registrieren oder uns anderweitig Informationen übermitteln, erheben wir nur solche Daten, die Ihr Browser an unseren Server übermittelt. 
          Wenn Sie unsere Website aufrufen, erheben wir die folgenden Daten, die für uns technisch erforderlich sind, um Ihnen die Website anzuzeigen:
        </p>
        <ul>
          <li>Unsere besuchte Website</li>
          <li>Datum und Uhrzeit zum Zeitpunkt des Zugriffes</li>
          <li>Menge der gesendeten Daten in Byte</li>
          <li>Quelle/Verweis, von welcher/welchem Sie auf die Seite gelangten</li>
          <li>Verwendeter Browser</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Verwendete IP-Adresse (ggf.: in anonymisierter Form)</li>
        </ul>
        <p>
          Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres berechtigten Interesses an der Verbesserung der Stabilität und Funktionalität unserer Website. Eine Weitergabe oder anderweitige Verwendung der Daten 
          findet nicht statt. Wir behalten uns allerdings vor, die Server-Logfiles nachträglich zu überprüfen, sollten konkrete Anhaltspunkte auf eine rechtswidrige Nutzung hinweisen.
        </p>

        <h2>2. Cookies</h2>
        <p>
          Als „Cookies“ werden kleine Dateien bezeichnet, die auf Geräten der Nutzer gespeichert werden. Innerhalb der Cookies können unterschiedliche Angaben gespeichert werden. Ein Cookie dient primär dazu, die Angaben zu einem Nutzer 
          (bzw. dem Gerät, auf dem das Cookie gespeichert ist) während oder auch nach seinem Besuch innerhalb eines Onlineangebotes zu speichern.
        </p>

        <h2>3. Kontaktaufnahme</h2>
        <p>
          Im Rahmen der Kontaktaufnahme mit uns (z.B. per Kontaktformular oder E-Mail) werden personenbezogene Daten erhoben. Diese Daten werden ausschließlich zum Zweck der Beantwortung Ihres Anliegens bzw. für die Kontaktaufnahme und die 
          damit verbundene technische Administration gespeichert und verwendet.
        </p>

        <h2>3. Kontaktaufnahme</h2>
        <p>
          Im Rahmen der Kontaktaufnahme mit uns (z.B. per Kontaktformular oder E-Mail) werden personenbezogene Daten erhoben. Diese Daten werden ausschließlich zum Zweck der 
          Beantwortung Ihres Anliegens bzw. für die Kontaktaufnahme und die damit verbundene technische Administration gespeichert und verwendet. 
        </p>

        <h2>4. Seitenfunktionalitäten</h2>
        <p>
          Wir nutzen den Dienst „Microsoft Teams“ der Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399 USA (nachfolgend „Microsoft Teams“) um Online-Meetings, 
          Videokonferenzen und/oder Webinare durchzuführen. Im Rahmen der Nutzung von Microsoft Teams werden Daten der Kommunikationsteilnehmer verarbeitet und auf Servern von 
          Microsoft Teams gespeichert.
        </p>

        <h2>5. Kontaktaufnahme</h2>
        <p>
          Bei der Kontaktaufnahme mit uns (z.B. per Kontaktformular, E-Mail, Telefon oder via sozialer Medien) werden die Angaben des Nutzers zur Bearbeitung der Kontaktanfrage 
          und deren Abwicklung gem. Art. 6 Abs. 1 lit. b DSGVO verarbeitet.
        </p>

        <h2>6. Tools und Sonstiges - Google Tag Manager</h2>
        <p>
          Google Tag Manager ist eine Lösung, mit der wir sog. Website-Tags über eine Oberfläche verwalten können. Der Tag Manager selbst verarbeitet keine personenbezogenen 
          Daten der Nutzer.
        </p>

        <h2>7. Tools und Sonstiges - Social Media</h2>
        <p>
          Wir unterhalten Onlinepräsenzen innerhalb sozialer Netzwerke und Plattformen, um mit den dort aktiven Kunden, Interessenten und Nutzern kommunizieren und sie dort über 
          unsere Leistungen informieren zu können.
        </p>

        <h2>8. Tools und Sonstiges - Google Analytics</h2>
        <p>
          Wir verwenden Google Analytics, um die Website-Nutzung zu analysieren. Die daraus gewonnenen Daten werden genutzt, um unsere Website sowie Werbemaßnahmen zu optimieren. 
          Google Analytics wird uns von Google Ireland Limited bereitgestellt. Google verarbeitet die Daten zur Website-Nutzung in unserem Auftrag und verpflichtet sich 
          vertraglich zu Maßnahmen, um die Sicherheit und Vertraulichkeit der verarbeiteten Daten zu gewährleisten.
        </p>

        <h2>9. Rechte des Betroffenen</h2>
        <p>
          Das geltende Datenschutzrecht gewährt Ihnen gegenüber dem Verantwortlichen hinsichtlich der Verarbeitung Ihrer personenbezogenen Daten die nachstehenden 
          Betroffenenrechte:
        </p>
        <ul>
          <li>Auskunftsrecht gemäß Art. 15 DSGVO</li>
          <li>Recht auf Berichtigung gemäß Art. 16 DSGVO</li>
          <li>Recht auf Löschung gemäß Art. 17 DSGVO</li>
          <li>Recht auf Einschränkung der Verarbeitung gemäß Art. 18 DSGVO</li>
          <li>Recht auf Datenübertragbarkeit gemäß Art. 20 DSGVO</li>
          <li>Recht auf Widerruf erteilter Einwilligungen gemäß Art. 7 Abs. 3 DSGVO</li>
          <li>Recht auf Beschwerde gemäß Art. 77 DSGVO</li>
        </ul>

        <h2>10. Widerspruchsrecht</h2>
        <p>
          Wenn wir im Rahmen einer Interessenabwägung Ihre personenbezogenen Daten aufgrund unseres überwiegenden berechtigten Interesses verarbeiten, haben Sie jederzeit das 
          Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, gegen diese Verarbeitung Widerspruch mit Wirkung für die Zukunft einzulegen.
        </p>

        <h2>11. Dauer der Speicherung personenbezogener Daten</h2>
        <p>
          Die Dauer der Speicherung von personenbezogenen Daten bemisst sich anhand der jeweiligen Rechtsgrundlage, am Verarbeitungszweck und – sofern einschlägig – 
          zusätzlich anhand der jeweiligen gesetzlichen Aufbewahrungsfrist.
        </p>

        <h2>12. Zusammenarbeit mit Auftragsverarbeitern und Dritten</h2>
        <p>
          Sofern wir im Rahmen unserer Verarbeitung Daten gegenüber anderen Personen und Unternehmen (Auftragsverarbeitern oder Dritten) offenbaren, sie an diese übermitteln 
          oder ihnen sonst Zugriff auf die Daten gewähren, erfolgt dies nur auf Grundlage einer gesetzlichen Erlaubnis.
        </p>

        <h2>13. Übermittlung in Drittländer</h2>
        <p>
          Sofern wir Daten in einem Drittland (d.h. außerhalb der EU oder des EWR) verarbeiten oder dies im Rahmen der Inanspruchnahme von Diensten Dritter oder Offenlegung, 
          bzw. Übermittlung von Daten an Dritte geschieht, erfolgt dies nur, wenn es zur Erfüllung unserer (vor)vertraglichen Pflichten, auf Grundlage Ihrer Einwilligung, 
          aufgrund einer rechtlichen Verpflichtung oder auf Grundlage unserer berechtigten Interessen geschieht.
        </p>
      </div>
    </div>
  );
};
